import React, { useLayoutEffect, useState } from 'react';
import { generatePath, Link } from 'react-router-dom';
import buildQuery from 'odata-query';
import BootstrapTable from 'react-bootstrap-table-next';
import api from '../../../services/api';
import _ from 'lodash';
import { StatusFormatter } from '../Formatter';
import { getUser } from '../../../../index';
/**
 *
 * @param {{
 *  query: { select: $select, search: $search, skiptoken: $skiptoken, format: $format, top, skip, filter, transform, orderBy, key, count, expand, action, func }?: Partial<QueryOptions<any>>,
 *  columns?: ColumnDescription<any, any>[]
 * }} param0
 * @returns
 */
let arrayEntities = {}
const TrainingTable = ({ viewOnly = false, standard = null, externalMaterial = null, editTraining = true, columns = [], ...pros }) => {
    
    const [entities, setEntities] = useState([]);
    const [iAmTrained, setIAmTrained] = useState(false);
    const [trainingId, setTrainingId] = useState(0);
    const [url, setUrl] = useState('');

    let _columns = [
        {
            dataField: 'user.name',
            text: 'Nome'
        },
        {
            dataField: 'user.sap',
            text: 'SAP'
        },
        {
            dataField: 'user.deparment.name',
            text: 'Departamento'
        },
        {
            dataField: 'user.companyRole.name',
            text: 'Grupo de função',
            formatter: (cellContent, row) => {
                return (
                    <>{cellContent.substr(0, cellContent.indexOf(" "))}</>
                )
            }
        },
        {
            dataField: 'status',
            text: 'Estado',
            formatter: (cellContent, row) => {
                return (
                    StatusFormatter(cellContent, row, standard, url)
                )
            }
        }
    ];

    if (columns.length > 1) {
        _columns = columns;
    }

    useLayoutEffect(() => {

        let _query = {
            select: ['userId, status', 'id'],
            expand: {
                user: {
                    select: ['id', 'name', 'sap'],
                    expand: [
                        'companyRole',
                        'deparment'
                    ]
                }
            },
            orderBy: ['user/name asc'],
            count: true
        }

        let itemId;
        let url;
        if (standard) {
            itemId = standard.id;
            url = `/training/standard/${itemId}`
            _query.filter =
            {
                standardId: itemId,
                user: { status: true }
            }

        }
        if (externalMaterial) {
            itemId = externalMaterial.id;
            url = `/training/externalmaterial/${itemId}`
            _query.filter =
            {
                ExternalMaterialId: itemId,
                user: { status: true }
            }
        }

        setUrl(url);
        setTrainingId(itemId);

        api.get('/TrainingUser/odata' + buildQuery(_query))
            .then((response) => {
                if (response.status === 200 && response.data['_count'] > 0) {
                    const _training = response.data.value;
                    arrayEntities = _training;
                    setEntities(arrayEntities);
                    _training.map(item => {
                        if (item.userId === getUser().id && item.status === true)
                            setIAmTrained(true);
                    })
                }
            }).catch(() => {

            });
    }, [standard]);
    return (
        <>
            {
                editTraining &&
                <div className="row text-center">
                    <Link className="btn btn-success" to={`/edittraining/${standard.identifier}`}>
                        Editar treinamentos
                    </Link>
                </div>
            }
            {
                (!iAmTrained && !viewOnly && ((standard && standard.status == 2) || externalMaterial)) &&
                <div className="row text-center">
                    <div className="mt-2 w-100">
                        <Link className="btn btn-primary" to={url}>
                            Confirmar que realizei o treinamento
                        </Link>
                    </div>
                </div>
            }
            <BootstrapTable
                keyField="id"
                data={entities}
                columns={_columns}
                id='collaboratorsPDF'
            />          
        </>
    );
};

export default TrainingTable;
